import moment from "moment";
import Tooltip from "components/General/Tooltip";
import { stringFormattingToCurrency } from "js/formatting";

const getCardFields = (cashValue, isInactiveStatus) => {
  if (isInactiveStatus) {
    return [
      {
        title: (
          <div className="flex items-center">
            Account Value
            <Tooltip
              content={`The value of all contributions and earnings less applicable charges and adjustments as of ${moment().format(
                "MM/DD/YYYY"
              )}`}
              xMargin="mx-1"
            />
          </div>
        ),
        value: stringFormattingToCurrency(0),
      },
      {
        title: "Surrender Charge",
        value: stringFormattingToCurrency(0),
      },
      {
        title: "Market Value Adjustment",
        value: stringFormattingToCurrency(0),
      },
      {
        title: "Surrender Value",
        value: stringFormattingToCurrency(0),
      },
      {
        title: "Surrender Charge Free Amount",
        value: stringFormattingToCurrency(0),
      },
    ];
  } else if (cashValue) {
    let {
      accountValue,
      estimatedSurrenderValue,
      marketValueAdjustment,
      penaltyFreeAmount,
      surrenderCharge,
    } = cashValue;

    return [
      {
        title: (
          <div className="flex items-center">
            Account Value
            <Tooltip
              content={`The value of all contributions and earnings less applicable charges and adjustments as of ${moment().format(
                "MM/DD/YYYY"
              )}`}
              xMargin="mx-1"
            />
          </div>
        ),
        value: stringFormattingToCurrency(accountValue),
      },
      {
        title: "Surrender Charge",
        value: stringFormattingToCurrency(surrenderCharge),
      },
      {
        title: "Market Value Adjustment",
        value: stringFormattingToCurrency(marketValueAdjustment),
        hidden:
          !marketValueAdjustment || parseFloat(marketValueAdjustment) === 0,
      },
      {
        title: "Surrender Value",
        value: stringFormattingToCurrency(estimatedSurrenderValue),
      },
      {
        title: "Surrender Charge Free Amount",
        value: stringFormattingToCurrency(penaltyFreeAmount),
        hidden: parseFloat(surrenderCharge) === 0,
      },
    ];
  } else {
    return [];
  }
};

export default getCardFields;
